import React from "react";

// Dashboard
const CrmDashboard = React.lazy(() => import("../../CRM/DashboardPages/crmdashboard"));

// Leads
const AddLeadTable = React.lazy(() =>
  import("../../CRM/LeadPages/leadaddpage").then((m) => ({
    default: m.AddLeadTable,
  })),
);
const LeadAddPage = React.lazy(() =>
  import("../../CRM/LeadPages/leadaddpage").then((m) => ({
    default: m.LeadAddPage,
  })),
);

// Clients
const AddClient = React.lazy(() =>
  import("../../CRM/Clientpages/addclient").then((m) => ({
    default: m.AddClient,
  })),
);
const ClientTableComp = React.lazy(() =>
  import("../../CRM/Clientpages/addclient").then((m) => ({
    default: m.ClientTableComp,
  })),
);

// Tasks - Meeting
const AddMeeting = React.lazy(() =>
  import("../../CRM/TaskPages/addmeeting").then((m) => ({
    default: m.AddMeeting,
  })),
);
const AddMeetingTable = React.lazy(() =>
  import("../../CRM/TaskPages/addmeeting").then((m) => ({
    default: m.AddMeetingTable,
  })),
);

// Tasks - Call
const AddCall = React.lazy(() =>
  import("../../CRM/TaskPages/addcall").then((m) => ({ default: m.AddCall })),
);
const AddCallTable = React.lazy(() =>
  import("../../CRM/TaskPages/addcall").then((m) => ({ default: m.AddCallTable })),
);

// Tasks - Other
const AddTask = React.lazy(() =>
  import("../../CRM/TaskPages/addtask").then((m) => ({ default: m.AddTask })),
);
const AddtaskTable = React.lazy(() =>
  import("../../CRM/TaskPages/addtask").then((m) => ({ default: m.AddtaskTable })),
);

// Teams
const AddTeam = React.lazy(() =>
  import("../../CRM/Teams/addteams").then((m) => ({ default: m.AddTeam })),
);
const TeamTable = React.lazy(() =>
  import("../../CRM/Teams/addteams").then((m) => ({ default: m.TeamTable })),
);

// Members
const AddMember = React.lazy(() =>
  import("../../CRM/Teams/addmembers").then((m) => ({ default: m.AddMember })),
);
const MemberTable = React.lazy(() =>
  import("../../CRM/Teams/addmembers").then((m) => ({ default: m.MemberTable })),
);

// Hierarchy
const MainHierarchyComp = React.lazy(() => import("../../CRM/Teams/hierarchy"));

// Availability
const AvailabilityComp = React.lazy(() => import("../../CRM/Reports/Availability"));

// Booking Units
const BookingUnits = React.lazy(() => import("../../Inventory/Availability/BookedUnits"));

export const crmRoutes = [
  {
    path: "/crm/dashboard",
    Component: CrmDashboard,
    rolename: "CRM Dashboard",
  },

  // Leads
  {
    path: "/crm/leads",
    Component: AddLeadTable,
    rolename: "Leads",
  },
  {
    path: "/crm/leads/add",
    Component: LeadAddPage,
    rolename: "Leads",
  },

  // Clients
  {
    path: "/crm/client/clients",
    Component: ClientTableComp,
    rolename: "Clients",
  },
  {
    path: "/crm/client/clients/add",
    Component: AddClient,
    rolename: "Clients",
  },

  // Tasks - Meeting
  {
    path: "/crm/tasks/meeting",
    Component: AddMeetingTable,
    rolename: "Meeting",
  },
  {
    path: "/crm/tasks/meeting/add",
    Component: AddMeeting,
    rolename: "Meeting",
  },

  // Tasks - Call
  {
    path: "/crm/tasks/call",
    Component: AddCallTable,
    rolename: "Call",
  },
  {
    path: "/crm/tasks/call/add",
    Component: AddCall,
    rolename: "Call",
  },

  // Tasks - Other
  {
    path: "/crm/tasks/othertask",
    Component: AddtaskTable,
    rolename: "Other Task",
  },
  {
    path: "/crm/tasks/othertask/add",
    Component: AddTask,
    rolename: "Other Task",
  },

  // Teams
  {
    path: "/crm/teams/teams",
    Component: TeamTable,
    rolename: "Add Team",
  },
  {
    path: "/crm/teams/teams/add",
    Component: AddTeam,
    rolename: "Add Team",
  },

  // Members
  {
    path: "/crm/teams/member",
    Component: MemberTable,
    rolename: "Member",
  },
  {
    path: "/crm/teams/member/add",
    Component: AddMember,
    rolename: "Member",
  },

  // Hierarchy
  {
    path: "/crm/teams/hierarchy",
    Component: MainHierarchyComp,
    rolename: "Hierarchy",
  },

  // Availability
  {
    path: "/crm/availability/availability",
    Component: AvailabilityComp,
    rolename: "Crm Availability",
  },
  {
    path: "/crm/availability/units",
    Component: BookingUnits,
    rolename: "Crm Units",
  },
];
